import React from 'react';
import { useParams } from 'react-router-dom';

import TicketsList from 'pages/Teams/components/TicketsList';
import TicketDetails from 'pages/Teams/components/TicketDetails';

import useStyles from './styles';

const Teams: React.FC = () => {
  const classes = useStyles();
  const { ticketId } = useParams();

  return (
    <div className={classes.container}>
      <TicketsList />

      {ticketId && <TicketDetails ticketId={ticketId} />}
    </div>
  );
};

export default Teams;
